"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.midRendererIconSizes = exports.midRendererIconKeys = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _styles = require("@material-ui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var MidRendererIcons = _interopRequireWildcard(require("../../../assets/icons/midrender/icons"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    xsmall: {
      width: 32,
      height: 32
    },
    small: {
      width: 36,
      height: 36
    },
    medium: {
      width: 48,
      height: 48
    },
    large: {
      width: 64,
      height: 64
    },
    xlarge: {
      width: 84,
      height: 84
    },
    xxlarge: {
      width: 120,
      height: 120
    }
  };
});
/**
 * ** Mid-render icons use the Vodafone grey and red, thus linking them to our brand colour
 * palette. However, by using two colours, the implementation is far more complicated compared
 * to that of System icons, so this set can only be used on white or very light grey backgrounds.
 * For other background colours, use the System icon set and reverse colour to white. Mid-render
 * icons range from 36 - 64px. As with the System icons, the line weight should always be 1 px
 * without exception. **
 *
 * There are 6 sizes: XSmall, Small, default, Large, XLarge, XXLarge
 *
 */

var MidRendererIcon = function MidRendererIcon(_ref) {
  var size = _ref.size,
      icon = _ref.icon;
  var styles = useStyles();
  return icon !== "" && /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    className: (0, _classnames.default)(styles[size]),
    component: MidRendererIcons[icon],
    viewBox: "0 0 192 192"
  });
};

MidRendererIcon.propTypes = {
  /** The MidRenderer icon key */
  icon: _propTypes.default.string.isRequired,

  /** The size variant of the icon (32px, 36px, 48px, 64px, 84px, 120px) */
  size: _propTypes.default.oneOf(["xsmall", "small", "medium", "large", "xlarge", "xxlarge"])
};
MidRendererIcon.defaultProps = {
  size: "medium"
};
var midRendererIconKeys = Object.keys(MidRendererIcons);
exports.midRendererIconKeys = midRendererIconKeys;
var midRendererIconSizes = ["xsmall", 'small', 'medium', 'large', "xlarge", "xxlarge"];
exports.midRendererIconSizes = midRendererIconSizes;
var _default = MidRendererIcon;
exports.default = _default;